import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YearPanel from './panel/YearPanel';
import MonthPanel from './panel/MonthPanel';
import TimePanel from './panel/TimePanel';
import DatePanel from './panel/DatePanel';
import DecadePanel from './panel/DecadePanel';
import WeekPanel from './panel/WeekPanel';
import Footer from './panel/BaseFooter';
import { DateUtil } from './util';
import './style/PickerPanel.less';

class BasePanel extends Component {
    static defaultProps = { showOk: true }

    /* 
     *   共同的一些方法、属性等，是否需要在这一层对回调做增强功能处理，如无需要，保留给以后方便扩展公共部分
     */
    constructor(props){
        super(props);
        this.realPanelRef = React.createRef();
    }

    getCellClassName = currentDate => {
        let { value, getCellClassName, mode } = this.props;
        return {
            'picker-cell-selected': DateUtil.isSame(currentDate, value, mode),
            ...getCellClassName?.(currentDate),
        };
    }

    generateCommonProps = () => {
        const { superPrev = true, prev = true, superNext = true, next = true } = this.props;
        return {
            ...this.props,
            superPrev, 
            prev, 
            superNext, 
            next,
            getCellClassName: this.getCellClassName,
        };
    }

    createPanel = commonProps => {
        const { mode } = commonProps;
        commonProps = { ...commonProps, ref: this.realPanelRef };
        switch(mode){
            case 'year':
                return <YearPanel {...commonProps}/>;
            case 'week':
                return <WeekPanel {...commonProps} />;
            case 'month':
                return <MonthPanel {...commonProps} />;
            case 'time':
                return <TimePanel {...commonProps} />;
            case 'date':
            case 'dateTime':
                return <DatePanel {...commonProps} />;
            case 'decade':
                return <DecadePanel {...commonProps} />;
            default:
                console.warn(`参数mode[${mode}]不是支持的选项`);
        }
    }

    onKeyDown = e =>{
        return this?.realPanelRef?.current?.onKeyDown?.(e);
    }

    render() {
        let { picker } = this.props;

        let commonProps = this.generateCommonProps();

        return <>
            {this.createPanel(commonProps)}
            {picker === 'dateTime' && <TimePanel {...commonProps} mode="time" />}
        </>;
    }
}

class PickerPanel extends Component{

    realPanelRef = React.createRef();

    onKeyDown = e =>{
        return this?.realPanelRef?.current?.onKeyDown?.(e);
    }

    render() {
        let { picker } = this.props;

        return <div className={`picker-panel panel-type-${picker}`} tabIndex="-1">
            <div className="picker-panel-container">
                <BasePanel {...this.props} ref={this.realPanelRef} />
            </div>
            {<Footer {...this.props}></Footer>}
        </div>;
    }
}

PickerPanel.PropTypes = {
    /* month year week time date, week和date显示是一样的，month和year显示是一样的，timer是dom结构差异的，
        一样的暂时还是分开写，因为有不同的事件，之后可以看是否有必要抽象共同部分为公共组件 */
    picker: PropTypes.string, 
    onSelect: PropTypes.func, /* 选择某个日期时回调，比如在picker = 'date' 时 年面板选择年，月面板选择月 */
    onChange: PropTypes.func, /* 根据picker，在最终选择的日期时回调 */
    /* 面板改变时的回调，参数1：面板类型改变的目标（month 变成monthpanel / year 变成yearPanel / null 不改变 ），参数2：改变后的date
     * 内部处理mode的改变，外部可根据自身需求决定是否关心该事件
     */
    onPanelChange: PropTypes.func, 
    value: PropTypes.object, /* 日期值Date对象 */
    onDateMouseEnter: PropTypes.func, /* 鼠标进入离开时，需要在input显示或清除显示日期，显示的颜色与select有所区别 */
    onDateMouseLeave: PropTypes.func,
    range: PropTypes.bool,
    extraFooter: PropTypes.object,
};

export default PickerPanel;
export { BasePanel };
